module.exports = __webpack_public_path__ + "img/money.66a6c23f.svg";